// src/hooks/usePageTracking.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * ページ遷移を自動的にトラッキングするカスタムフック
 */
export const usePageTracking = (): void => {
  const location = useLocation();

  useEffect(() => {
    // canonical をルートごとに自己参照へ更新(index.html の静的 canonical は "/" 固定のため)
    if (typeof document !== 'undefined') {
      let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = `${window.location.origin}${location.pathname}`;
    }

    // ページビューをトラッキング
    trackPageView(location.pathname + location.search, document.title);

    // GTM用のdataLayerにもpush
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'page_view',
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);
};
